// Servicio principal de autenticación que coordina Firebase y PetFlix
import firebaseAuthService from './firebaseAuthService';
import petflixAuthService from './petflixAuthService';

class AuthService {
  constructor() {
    this.currentUser = null;
    this.isAuthenticating = false;
  }

  // Flujo simplificado de autenticación solo con email
  async requestOTP(email, firstName, lastName) {
    try {
      this.isAuthenticating = true;
      console.log('Solicitando OTP para:', email);
      if (firstName && lastName) {
        console.log('Nombre completo:', firstName, lastName);
      }

      const result = await petflixAuthService.requestOTP(email, firstName, lastName);
      
      if (result.success) {
        console.log('OTP solicitado exitosamente');
        return {
          success: true,
          data: result.data
        };
      } else {
        throw new Error(`OTP request failed: ${result.error}`);
      }

    } catch (error) {
      console.error('OTP request error:', error);
      return {
        success: false,
        error: error.message
      };
    } finally {
      this.isAuthenticating = false;
    }
  }

  // Flujo de autenticación con número de teléfono
  async requestPhoneOTP(phoneNumber) {
    try {
      this.isAuthenticating = true;
      console.log('Solicitando OTP por teléfono:', phoneNumber);

      const result = await petflixAuthService.requestPhoneOTP(phoneNumber);
      
      if (result.success) {
        console.log('OTP por teléfono solicitado exitosamente');
        return {
          success: true,
          data: result.data
        };
      } else {
        throw new Error(`Phone OTP request failed: ${result.error}`);
      }

    } catch (error) {
      console.error('Phone OTP request error:', error);
      return {
        success: false,
        error: error.message
      };
    } finally {
      this.isAuthenticating = false;
    }
  }


  // Verificar OTP
  async verifyOTP(email, otp) {
    try {
      const result = await petflixAuthService.verifyOTP(email, otp);
      return result;
    } catch (error) {
      console.error('OTP verification error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Verificar OTP por teléfono
  async verifyPhoneOTP(phoneNumber, otp) {
    try {
      const result = await petflixAuthService.verifyPhoneOTP(phoneNumber, otp);
      return result;
    } catch (error) {
      console.error('Phone OTP verification error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Obtener usuario actual
  getCurrentUser() {
    return this.currentUser;
  }

  // Verificar si está autenticado
  isAuthenticated() {
    return petflixAuthService.isAuthenticated() && this.currentUser !== null;
  }

  // Cerrar sesión
  logout() {
    this.currentUser = null;
    petflixAuthService.clearAccessToken();
  }

  // Obtener token de acceso
  getAccessToken() {
    return petflixAuthService.getAccessToken();
  }

  // Verificar si está en proceso de autenticación
  isAuthenticating() {
    return this.isAuthenticating;
  }

  // Cambiar modo testing
  setTestingMode(enabled) {
    petflixAuthService.setTestingMode(enabled);
  }

  // Obtener estado del modo testing
  isTestingMode() {
    return petflixAuthService.isTestingMode();
  }
}

export default new AuthService();
